import { render, staticRenderFns } from "./ApplicationShell.vue?vue&type=template&id=7480ce91&"
import script from "./ApplicationShell.ts?vue&type=script&lang=ts&"
export * from "./ApplicationShell.ts?vue&type=script&lang=ts&"
import style0 from "./ApplicationShell.vue?vue&type=style&index=0&id=7480ce91&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports